<style lang="scss" scoped>
button{
  width: 498px;
  height: 105px;
  background: url('./../assets/img/anniu-da.svg') no-repeat;
  background-size: cover;
  font-size:27px;
  font-family:PingFangSC-Semibold;
  font-weight:600;
  color:rgba(194,52,18,1);
  line-height:37px;
  cursor: pointer;
  &:active{
    opacity: 0.9;
  }
}
</style>

<template>
  <button @click="OpenLink">{{text}}</button>
</template>

<script>
export default {
  props: {
    text: String,
    link: String
  },
  methods: {
    OpenLink() {
      // location.href = this.link;
      window.open(this.link);
      
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/bigButton.vue